/* eslint-disable */

export default {
  init() {
    // JavaScript to be fired on all pages
    let mobileMenuActive = false;

    const hamburgerButtonElement = $('#hamburger-button');
    const mobileMenu = $('#navigation');

    hamburgerButtonElement.on('click', toggleMobileMenu);

    function toggleMobileMenu() {
      mobileMenuActive != mobileMenuActive;

      hamburgerButtonElement.toggleClass('is-active');
      mobileMenu.toggleClass('is-active');
    }

    //Make last letter period or questionmark something else
    $(
      '.block--white h1, .block--image h1, .block--blue h1, .block--grey h1, .block--white h3, .block--image h3, .block--blue h3, .block--grey h3'
    ).each((i, item) => {
      const theText = $(item).text();
      const lastLetter = theText[theText.length - 1];

      if (lastLetter === '.' || lastLetter === '?') {
        $(item).html(() => {
          return (
            theText.substr(0, theText.length - 1) +
            '<span class="orange-it">' +
            theText.slice(-1) +
            '</span>'
          );
        });
      }
    });

    // Slick carrousel
    const slickSettings = {
      slidesToShow: 6,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      dots: true,

      responsive: [
        {
          breakpoint: 2400,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1800,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1240,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 1
          }
        },
        {
          breakpoint: 599,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    };

    $('.carrousel').slick(slickSettings);
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  }
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js